import { driver, Config as DriverConfig } from "driver.js";
import "driver.js/dist/driver.css";
import "../../driver.css";
import { useEffect, useState } from "react";
import { DEFAULT_TOUR_CONFIG } from "@/lib/defaultTourConfig";

const TOUR_CONFIG = {
  ...DEFAULT_TOUR_CONFIG,
  steps: [
    {
      element: '[data-agents-page-tour="search-input"]',
      popover: {
        title: "Find agents",
        description: "Use the search bar to quickly find agents.",
        side: "bottom",
        align: "center",
      },
    },
    {
      element: '[data-agents-page-tour="first-persona-item"]',
      popover: {
        title: "Agent details",
        description:
          "Select an individual agent to go to the Agent Details page.",
        side: "bottom",
        align: "center",
      },
    },
    {
      element: '[data-agents-page-tour="create-agent-button"]',
      popover: {
        title: "Create your agent",
        description:
          "Design, deploy, and tokenize your adaptive agents! Click here to start your journey!",
        side: "bottom",
        align: "center",
      },
    },
  ],
} satisfies DriverConfig;

const AGENTS_PAGE_TOUR_KEY = "agentsPageTourSeen";

export function useAgentsPageTour() {
  const [hasCompletedTour, setHasCompletedTour] = useState(() => {
    try {
      // Test if we can write to localStorage
      localStorage.setItem(
        AGENTS_PAGE_TOUR_KEY,
        localStorage.getItem(AGENTS_PAGE_TOUR_KEY) || "",
      );
      // Only show if we can confirm it's never been seen
      const hasSeenDialog = localStorage.getItem(AGENTS_PAGE_TOUR_KEY);
      return hasSeenDialog !== "";
    } catch {
      return true;
    }
  });

  const [driverObj] = useState(() =>
    driver({
      ...TOUR_CONFIG,
      onDestroyStarted: () => {
        /* When the tour is either completed or exited, stop showing it. */
        try {
          localStorage.setItem(AGENTS_PAGE_TOUR_KEY, "true");
        } catch {
          /* Intentionally empty. There's nothing else we can do if we can't access localStorage */
          setHasCompletedTour(true);
        }
        setHasCompletedTour(true);

        driverObj.destroy();
      },
    }),
  );

  useEffect(
    () => () => {
      driverObj.destroy();
    },
    [driverObj],
  );

  return {
    hasCompletedTour,
    startTour: driverObj.drive,
  };
}
